
export default {
  name: 'Empty',
}
